
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employer-center",
      function () {
        return require("private-next-pages/employer-center/index.js");
      }
    ]);
  